export default __webpack_public_path__ + "static/media/planning-icon.87d76bd4.svg";